<div class="info-tooltip" tabindex="-1" *ngIf="infoModal">
  <img
    class="info-tooltip__icon"
    machTooltip
    src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
    alt="title"
    role="button"
    tabindex="0"
    [tooltipContent]="{
      position: toolTipPosition,
      hideCloseIcon: false,
      hover: true,
      info: '',
      color: '#fff',
      background: '#001E3C',
      closeIcon:
        '/content/dam/delta-applications/sitewide/capability/flight-shop/images/close-white-icon.svg'
    }"
    [template]="customTooltip"
  />
</div>

<ng-template #customTooltip>
  <div class="info-tooltip-content__container">
    <div
      class="info-tooltip-content__container__title"
      *ngIf="infoModal.title"
      [innerHTML]="infoModal.title"
    ></div>
    <div
      *ngIf="infoModal.description"
      class="info-tooltip-content__container__desc"
      [innerHTML]="infoModal.description"
    ></div>
  </div>
</ng-template>
